module.exports = __webpack_public_path__ + "media/sitemap_page/images/btn_pagetop-199dbbc7b397213f16d272f6219f0721.png";